export default "__VITE_ASSET__c2b2e7aa__"